import { CardGrid } from '@liveauctioneers/hammer-ui-core/card/cardGrid';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getUpcomingSalesItemIds, getViewMoreUrl } from '@/redux/modules/priceResults/priceResults.selectors';
import { H2 } from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import { ItemSummary } from '@/types/item/ItemSummary';
import { SubtleLink } from '@liveauctioneers/hammer-ui-core/link';
import { UpcomingSalesItemCard } from './components/UpcomingSalesItemCard/UpcomingSalesItemCard';
import { UpcomingSort } from './components/UpcomingSort/UpcomingSort';
import { useAppSelector } from '@/redux/hooks';
import { useMemo } from 'react';

type Props = {
    itemId: number;
    slug: string;
};

export const PriceResultsUpcomingSales = ({ itemId, slug }: Props) => {
    const upcomingSalesItemIds = useAppSelector(getUpcomingSalesItemIds);
    const items = useAppSelector((state) => getItemSummaries(state, upcomingSalesItemIds));

    const viewMoreUrl = useAppSelector(getViewMoreUrl);

    const itemCardData = useMemo(() => {
        return items.reduce(
            (acc, lot) => {
                acc[lot.itemId] = lot;
                return acc;
            },
            {} as Record<string, ItemSummary>
        );
    }, [items]);

    return (
        <div className="xsMax:px-sm">
            <div className="flex w-full items-center justify-between border-b border-border-secondary pb-xs">
                <H2>Upcoming Sales</H2>
                <SubtleLink
                    aria-label="View All"
                    href={viewMoreUrl}
                >
                    View All
                </SubtleLink>
            </div>
            <UpcomingSort
                itemId={itemId}
                slug={slug}
            />
            <CardGrid
                card={UpcomingSalesItemCard}
                cardData={itemCardData}
                cards={Object.keys(itemCardData)}
                className="w-full mobile:grid-cols-2"
                colsByBreakpoint={{
                    lg: 4,
                    md: 4,
                    sm: 4,
                    xl: 4,
                    xs: 3,
                }}
                gapsByBreakpoint={{ md: '24px', sm: '16px', xs: '16px' }}
            />
        </div>
    );
};
